import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function YanginEgitimiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'Yangın Eğitimi | Adana OSGB Mersin Hatay Osmaniye | ASSA Akademi';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana yangın eğitimi, Mersin yangın eğitimi, Hatay yangın eğitimi, Osmaniye yangın eğitimi ve tatbikatı. ASSA Akademi yangın güvenliği, söndürme teknikleri, tahliye planları eğitimi.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana yangın eğitimi, Mersin yangın eğitimi, Hatay yangın eğitimi, Osmaniye yangın eğitimi, yangın tatbikatı, yangın söndürme');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/egitimler/yangin-egitimi');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Course",
      "name": "Yangın Eğitimi ve Tatbikatı",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde ASSA Akademi yangın güvenliği ve müdahale eğitimi.",
      "provider": {
        "@type": "Organization",
        "name": "ASSA Akademi",
        "telephone": "+90-850-346-2772"
      },
      "areaServed": ["Adana", "Mersin", "Hatay", "Osmaniye"],
      "url": "https://www.assaosgb.com.tr/egitimler/yangin-egitimi"
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-orange-600 to-red-600 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Yangın Eğitimi ve Tatbikatı</h1>
            <p className="text-xl md:text-2xl mb-8 text-orange-100">
              ASSA Akademi ile Yangın Güvenliği ve Müdahale Eğitimi
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-lg">
              <span className="bg-white/20 px-4 py-2 rounded-full">Adana Yangın Eğitimi</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Mersin Yangın Eğitimi</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Hatay Yangın Eğitimi</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Osmaniye Yangın Eğitimi</span>
            </div>
          </div>
        </div>
      </section>

      {/* ASSA Akademi Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">ASSA Akademi</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Adana, Mersin, Hatay ve Osmaniye illerinde yangın güvenliği konusunda 
              uzmanlaşmış ASSA Akademi, teorik ve uygulamalı eğitimlerle yangın risklerine karşı hazırlık sağlar.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/453937987ba5e9ebaa2fdb347cae4d65.jpg"
                alt="ASSA Akademi Yangın Eğitimi"
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center">
                  <i className="ri-fire-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Uygulamalı Tatbikat</h3>
                  <p className="text-gray-600">Gerçek yangın senaryoları ile uygulamalı müdahale eğitimi</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-fire-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Yangın Söndürme</h3>
                  <p className="text-gray-600">Farklı yangın türleri için uygun söndürme yöntemleri</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-600 rounded-lg flex items-center justify-center">
                  <i className="ri-alarm-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Erken Uyarı Sistemleri</h3>
                  <p className="text-gray-600">Yangın alarm sistemleri ve acil durum prosedürleri</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Eğitim İçeriği */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Yangın Eğitimi İçeriği</h2>
            <p className="text-lg text-gray-600">Kapsamlı yangın güvenliği eğitimi programımız</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-fire-line text-orange-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Yangın Türleri</h3>
              <p className="text-gray-600">A, B, C, D ve F sınıfı yangınların özellikleri ve müdahale yöntemleri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-fire-line text-orange-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Yangın Söndürücüler</h3>
              <p className="text-gray-600">Farklı söndürücü türleri ve kullanım teknikleri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-run-line text-orange-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Tahliye Planları</h3>
              <p className="text-gray-600">Acil durum tahliye yolları ve toplanma alanları</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-smoke-line text-orange-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Duman ve Gaz Tehlikeleri</h3>
              <p className="text-gray-600">Yangın sırasında oluşan duman ve zehirli gazlardan korunma</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-alarm-warning-line text-orange-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Yangın Önleme</h3>
              <p className="text-gray-600">Yangın risklerinin belirlenmesi ve önleme stratejileri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-first-aid-kit-line text-orange-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Yanık Müdahalesi</h3>
              <p className="text-gray-600">Yangın sonrası yaralanmalara ilk yardım müdahalesi</p>
            </div>
          </div>
        </div>
      </section>

      {/* Şehirler */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Hizmet Verdiğimiz İller</h2>
            <p className="text-lg text-gray-600">ASSA Akademi Yangın Eğitimleri</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Adana</h3>
              <p className="text-gray-600">Adana Yangın Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Mersin</h3>
              <p className="text-gray-600">Mersin Yangın Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hatay</h3>
              <p className="text-gray-600">Hatay Yangın Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-fire-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Osmaniye</h3>
              <p className="text-gray-600">Osmaniye Yangın Eğitimi</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-orange-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Yangın Eğitimi Almak İster misiniz?</h2>
          <p className="text-xl text-orange-100 mb-8">
            ASSA Akademi ile yangın güvenliği konusunda uzmanlaşın
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/iletisim" 
              className="bg-white text-orange-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Bilgi Al
            </Link>
            <a 
              href="tel:08503462772" 
              className="bg-orange-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-orange-800 transition-colors whitespace-nowrap"
            >
              Hemen Ara
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
